module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }